import script from "./AddTeacherForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTeacherForm.vue?vue&type=script&setup=true&lang=js"

import "./AddTeacherForm.vue?vue&type=style&index=0&id=0d0d6b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d0d6b50"]])

export default __exports__